import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';
import { useOwner } from '../context/context.js';
import AgentsLogs from '../../containers/AgentsLogs.js';


const SecurityCenterLogs = ({ ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const owner = useOwner();
	const promotion = owner?.promotion?.Promotion ?? false;
/*			agents:JSON.parse('<?=safeJSON($agents);?>'),
			labels:JSON.parse('<?=safeJSON($labels);?>'),
			roles:JSON.parse('<?=safeJSON($roles);?>'),
		});*/
	return (
		<AgentsLogs
			promotion={promotion}
			agent_id={owner.agent.Agent.id}
			agents={props.agents}
			type='security'
		/>
	);
}

export default injectIntl(SecurityCenterLogs);